import { RouteErrorFallback } from "@cynthai/ui/RouteErrorFallback.tsx";
import { createRouter } from "@tanstack/react-router";

import { reportRouteError } from "@/core/lib/observability";
import { queryClient } from "@/core/lib/query-client";
import { appStringifySearch } from "@/core/lib/search-params";
import type { RouteContext } from "@/core/lib/types";
import { routeTree } from "@/routeTree.gen";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultStructuralSharing: true,
  stringifySearch: appStringifySearch,
  context: { user: null, appInfo: null, queryClient } satisfies RouteContext,
  defaultErrorComponent: RouteErrorFallback,
  defaultOnCatch: reportRouteError,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
